<template>
  <footer class="footer">
    <b-container class="cta">
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button href="https://discord.gg/snkrhud" class="cta__button" target="_blank">
            <img src="@/assets/footer/discord-join-now.png" class="img-fluid" alt="" />
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid="lg" class="links">
      <b-row class="flex-column flex-lg-row">
        <b-col class="links__about">
          <h5 class="links__title">About</h5>
          <b-link 
            class="links__about--link"
            to="/about-us"
          >
            <img
              src="@/assets/footer/snkrhud-logo.png"
              alt="snkrhud"
              class="ftr-snkrhud-logo img-fluid"
            />
          </b-link>
        </b-col>
        <b-col lg="3" class="links__socials">
          <h5 class="links__title">Socials</h5>
          <div class="links__socials--wrapper">
            <b-link
              class="links__socials--icon"
              href="https://www.instagram.com/snkrhud/?hl=en"
              target="_blank"
            >
              <img src="@/assets/footer/socials/instagram.png" alt="instagram" class=" img-fluid" />
            </b-link>
            <b-link
              class="links__socials--icon"
              href="https://www.facebook.com/SNKRHUD/"
              target="_blank"
            >
              <img src="@/assets/footer/socials/facebook.png" alt="facebook" class=" img-fluid" />
            </b-link>
            <b-link
              class="links__socials--icon"
              href="https://twitter.com/snkrhud?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
              target="_blank"
            >
              <img src="@/assets/footer/socials/twitter.png" alt="twitter" class=" img-fluid" />
            </b-link>
            <b-link class="links__socials--icon" href="mailto:help@snkrhud.com" target="_blank">
              <img src="@/assets/footer/socials/gmail.png" alt="gmail" class=" img-fluid" />
            </b-link>
          </div>
        </b-col>
        <b-col class="links__partners">
          <h5 class="links__title">Partners</h5>
          <div class="links__partners--wrapper">
            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/flow.png"
                alt="flow"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>
            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/dapper.png"
                alt="dapper"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>
            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/snap.png"
                alt="snap inc"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>

            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/orange.png"
                alt="orange dao"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>
            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/gaingels.png"
                alt="gaingels"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>

            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/redbeard.png"
                alt="redbeard ventures"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>
            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/audacity.png"
                alt="audacity fund"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>

            <b-link class="links__partners--icon" href="#">
              <img
                src="@/assets/footer/partners/gaia.png"
                alt="gaia"
                class="ftr-partners-logo img-fluid"
              />
            </b-link>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="terms">
      <div class="row">
        <b-col class="d-flex justify-content-center">
          <router-link to="/terms-and-condition" class="terms__link">
            Terms and Condition
          </router-link>
        </b-col>
      </div>
    </b-container>
  </footer>
</template>
<script>
export default {
  name: "footercontent"
};
</script>
<style lang="scss" scoped>
@import "../styles/components/footer.scss";
</style>
